import { LessonLink } from "@jelly/lesson";
import { findChapterForLinkByCourseLesson } from "../../../../services/Utils";
import course04 from "../../../course/course-04/course";
import lesson0428 from "../../course-04/lesson-28/lesson";
import lesson0429 from "../../course-04/lesson-29/lesson";

const lessonLinks: LessonLink[] = [
  {
    id: "4e3574ce-ff86-49dc-a301-b06edd287a42",
    course: {
      id: course04.id,
      slug: course04.slug as string,
      name: course04.name,
      publicId: course04.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course04, lesson0428),
    lesson: lesson0428,
  },
  {
    id: "667f347b-8710-4a97-8cf3-f6fcb5ce869f",
    course: {
      id: course04.id,
      slug: course04.slug as string,
      name: course04.name,
      publicId: course04.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course04, lesson0429),
    lesson: lesson0429,
  },
];

export default lessonLinks;
